<template>
  <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
  >
    <v-card>
      <v-card-title class="headline">
        Editar {{ itemType.slice(0, -1) }}
        <v-spacer></v-spacer>
        <v-switch
            :color="item.status
                ? 'success'
                : 'secondary lighten-3'"
            v-model="item.status"
            label="Estado"
            class="mt-0 pt-0"
            hide-details
        >
          <template v-slot:label>
            <StatusChip :status="item.status"/>
          </template>
        </v-switch>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form ref="formEditItem" @submit.prevent="editItem">
          <v-text-field
              v-model="item.name"
              label="Nombre"
              outlined
              dense
              required
              :rules="[rules.required, rules.counter]"
          ></v-text-field>
          <v-textarea
              v-model="item.description"
              label="Descripción"
              outlined
              dense
              rows="6"
              no-resize
              maxlength="255"
              counter
          ></v-textarea>
          <v-list dense class="py-0">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title class="caption grey--text">
                  Creado el {{ formatDate(originalItem.createdAt) }} por {{ originalItem.createdBy }}
                </v-list-item-title>
                <v-list-item-subtitle class="caption grey--text" v-if="originalItem.updatedAt">
                  Última actualización el {{ formatDate(originalItem.updatedAt) }} por {{ originalItem.updatedBy }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CancelButton
            :isDisabled="isLoading"
            @click="handleDialogClose"
        />
        <SaveButton
            :isLoading="isLoading"
            :isDisabled="isInvalidForm()"
            @click="editItem"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

import throwSuccessMessage from "@/utils/SuccessMessage";

import CatalogService from "@/services/catalogs/CatalogService";
import StatusChip from "@/components/StatusChip.vue";
import CancelButton from "@/components/buttons/CancelButton.vue";
import SaveButton from "@/components/buttons/SaveButton.vue";

export default Vue.extend({
  name: "DialogEditItem",
  components: {SaveButton, CancelButton, StatusChip},
  props: {
    itemType: {
      type: String,
      required: true
    },
    originalItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // Dialog
      dialog: false as boolean,

      // Item
      item: {
        name: "" as string,
        description: "" as string,
        status: false as boolean,
      },

      // Loading
      isLoading: false as boolean,

      // Rules
      rules: {
        required: (value: string) => !!value || 'Campo requerido',
        counter: (value: string) => (value || '').length <= 50 || 'Máximo 50 caracteres',
      },
    };
  },

  watch: {
    originalItem: {
      handler() {
        this.item = {...this.originalItem};
      },
      immediate: true
    }
  },

  methods: {
    async editItem() {
      this.isLoading = true;
      try {
        if (this.isInvalidForm()) return;
        await CatalogService.editItem(this.item, this.itemType);
        throwSuccessMessage(`Se ha editado ${this.item.name} correctamente`);
        this.$emit("item-created");
        this.handleDialogClose();
      } finally {
        this.isLoading = false;
      }
    },

    isInvalidForm() {
      if (!this.item.name) return true;
    },

    formatDate(date: string) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },

    handleDialogClose() {
      const form = this.$refs.formEditItem as any;
      form.resetValidation();
      this.item = {...this.originalItem};
      this.dialog = false;
    },
  }
});
</script>